<template>
  <section>
    <div class="ibox-content" @click.self="open = false">
        <b-tabs v-model="tabIndex">
          <b-tab v-if="!isLiteMode" :title="$t('topTitle')">
            <div class="panel-body user-itembox" v-if="tabIndex == 0">
              <label>{{orderType}}</label>
              <section>
                <div v-for="(obj, index) in getObjectivesByUser" :key="obj.id" v-if="obj.objective.contentText" class="ibox" v-observe-visibility="visibilityChanged" :accessKey="index">
                    <div @click="onClickObjective(obj.objective, obj.key)"  class="ibox-title cursor" v-bind:class="{ isForceBrowsing: !!obj.objective.isForceBrowed }">
                      <objective :detailView="false" :content="obj.objective.contentText" :progress="obj.objective.progress ? obj.objective.progress : '0'" :setReadOnly="'false'" :objective="true"/>
                      <div class="ibox-tools">
                        <span @click.stop="setKeyresultOpen(obj.key)" class="info-menu cursor">
                          <!-- <a class="collapse-link">
                            <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                          </a> -->
                          <button class="btn btn-secondary">
                            <i :class="{'chevronUp' : !getIsOpen(obj.key)}" class="fa fa-chevron-down"></i>
                            <span v-if="!getIsOpen(obj.key)">{{$t('indicateItemClose')}}</span>
                            <span v-else>{{$t('indicateAllNotice')}}</span>
                          </button>
                        </span>
                        <span class="info-right">
                          <span class="info-comment-detail" v-if="obj.objective.hasOwnProperty('sharedOwners') && Object.keys(obj.objective['sharedOwners']).length > 0">
                           <img :src="'static/img/assets/nav_people_on.png'">
                          </span>
                          <span class="info-comment-detail">
                            <img src="static/img/assets/comment.png">
                            <span v-bind:class="{ unread: isUnreadCommentsExist('objectives', obj.key, obj.objective.comments) }">{{getCommentsByCommentIdsTargetType(obj.objective.comments || {}, 'objectives').length}}</span>
                        </span>
                        <span class="info-comment-detail">
                          <img src="static/img/assets/relation_object_list.png">
                          <span v-bind:class="{ unread: isUnreadOKRRelationExist(obj.objective, obj.key, 'objectives') }">{{ obj.objective.relations ? Object.keys(obj.objective.relations).length : 0 }}</span>
                        </span>
                        <div class="info-comment-right">
                          <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{obj.objective.startDate}}</span>
                          <span class="info-comment-detail date-color">{{$t('dueDateStr')}} : {{obj.objective.dueDate}}</span>
                        </div>
                          <okr-drop-down :tag="tag" :item="obj.objective" :id="obj.key"/>
                        </span>
                      </div>
                    </div>
                    <div :class="{'keyResultClose' : getIsOpen(obj.key)}" class="ibox-content key-indent">
                        <!-- ボックス -->
                        <!-- KeyResult1 -->
                        <div @click="onClickKeyresult(keyresult, key)" v-for="(keyresult, key) in getOtherUserTargetKeyresults(userId, obj.objective.keyresults)" :key="key" v-if="keyresult.contentText" class="ibox-child cursor" :class="{'comp-mark' : getIsComp(keyresult), 'isForceBrowsing' : keyresult.isForceBrowed}">
                          <div>
                            <span class="comp"></span>
                            <objective :detailView="false" :content="keyresult.contentText" :progress="keyresult.progress ? keyresult.progress : '0'" :setReadOnly="'false'" :objective="false"/>
                          </div>
                          <div class="ibox-tools">
                            <span class="info-menu"></span>
                            <span class="info-right">
                              <span class="info-comment-detail" v-if="keyresult.hasOwnProperty('sharedOwners') && Object.keys(keyresult['sharedOwners']).length > 0">
                               <img :src="'static/img/assets/nav_people_on.png'">
                              </span>
                              <span class="info-comment-detail">
                                <img src="static/img/assets/comment.png">
                                <span v-bind:class="{ unread: isUnreadCommentsExist('keyresults', key, keyresult.comments) }">{{getCommentsByCommentIdsTargetType(keyresult.comments || {},'keyresults').length}}</span>
                              </span>
                              <span class="info-comment-detail">
                                <img src="static/img/assets/relation_object_list.png">
                                <span v-bind:class="{ unread: isUnreadOKRRelationExist(keyresult, key, 'keyresults') }">{{ keyresult.relations ? Object.keys(keyresult.relations).length : 0 }}</span>
                              </span>
                              <div class="info-comment-right">
                                <span class="info-comment-detail date-color block-display">{{$t('startDateStr')}} : {{keyresult.startDate}}</span>
                                <span class="info-comment-detail date-color">{{$t('dueDateStr')}} : {{keyresult.dueDate}}</span>
                              </div>
                                <okr-drop-down :tag="'progressKey'" :item="obj.objective" :id="key"/>
                            </span>
                          </div>
                        </div>
                        <!-- /KeyResult1  -->
                    <!-- /ボックス -->
                    </div>
                </div>
            </section>
            </div>
        </b-tab>
        <b-tab :title="$t('oneOnTileType')">
              <div class="panel-body user-itembox" v-if="(tabIndex == 0 && isLiteMode) || (tabIndex == 1 && !isLiteMode)">
                <section>
                  <!-- 1on1item -->
                  <div v-for="(oneItem, index) in get1on1sByUser" :key="oneItem.id" v-if="oneItem.one.contents" v-observe-visibility="visibilityChanged" :accessKey="index" class="ibox" v-bind:class="{ isForceBrowsing: !!oneItem.one.isForceBrowed }">
                    <div class="ibox-title">
                      <div class="flex-box fl-between">
                        <h3 class="h3">{{$t('retrospectiveStr').replace('{$date}', oneItem.one.date)}}</h3>
                        <div id="partnerInfo" class="partnerinfo" v-if="oneItem.one.partner">
                          <span class="partner-userimg">
                            <img v-if="getUserInfoById(oneItem.one.partner).userIcon" :src="getUserInfoById(oneItem.one.partner).userIcon" alt="image" class="img-circle"></img>
                            <img v-else :src="'static/img/noImage.png'" alt="image" class=img-circle>
                          </span>
                          <div class="partner-userinfo"><span class="public-username">{{getUserInfoById(oneItem.one.partner).userName}}</span></div>
                        </div>
                        <div><one-drop-down :item="oneItem.one" :id="oneItem.key"/></div>
                      </div>
                    </div>
                    <div class="ibox-content">
                      <div v-for="count in checkContent1on1" :key="count.id" @click="onClickOneItem(oneItem.one, oneItem.key , count -1)" id="one-item2" class="ibox-child one-child cursor">
                        <div class="flex-box cursor">
                          <img class="one-icon" :src="'static/img/1on1/img0' + count + '.png'" alt="">
                          <div class="comment">
                            <div class="flex-box fl-between">
                              <h4 class="h3">{{contentTitle[count-1]}}</h4>
                              <span class="info-comment-detail">
                                <img class="info-icon" src="static/img/assets/comment.png">
                                <span v-bind:class="{ unread: get1on1UnreadCommentKeys('1on1s_'+ String(count-1), oneItem.key, oneItem.one.comments) }">{{ getCommentsByCommentIdsTargetType(oneItem.one.comments || {}, '1on1s_' + [count-1]).length }}</span>
                                <a class="info-comment-detail" href="#">
                                  <img class="star" v-if="isOneLiked(oneItem.one.likes,count-1)" @click.stop="onClickOneStarLiked(oneItem.key,count-1)" :src="'static/img/assets/nice_on.png'">
                                  <img class="star" v-else @click.stop="onClickOneStarNotLiked(oneItem.key,count-1)" :src="'static/img/assets/nice_off.png'">
                                  <span class="like-counter" @click.stop="showOneModalLikes(oneItem, count-1)" v-if="!!oneItem.one && !!oneItem.one.likes && !!oneItem.one.likes.hasOwnProperty(count-1)"><strong v-bind:class="{ unread: isUnreadOneLikeExist(oneItem.key, getUserId, oneItem.one.likes[count-1], count-1) }">{{ oneItem.one.likes[count-1] ? Object.keys(oneItem.one.likes[count-1]).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                                </a>
                              </span>
                            </div>
                            <one-item :detailView="false" :item="oneItem.one.contents[count-1]"/>
                          </div>
                        </div>
                      </div>
                      <!-- 1on1Component2 -->
                        <!-- <div @click="onClickOneItem(oneItem, key , 0)" id="one-item2" class="ibox-child one-child cursor">
                          <div class="flex-box cursor">
                            <img class="one-icon" src="static/img/1on1/img02.png" alt="">
                            <div class="comment">
                              <h4 class="h4">{{$t('secContent1on1')}}</h4>
                              <one-item :detailView="false" :item="oneItem.contents[0]"/>
                              <div class="ibox-tools">
                                <span class="info-menu">
                                  <a class="info-comment-detail" >
                                    <img src="static/img/assets/comment.png">
                                    <span>{{ getCommentsByCommentIdsTargetType(key,'1on1s_0').length }}</span>
                                  </a>
                                </span>
                                <span class="info-right"></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- /1on1Component2  -->
                        <!-- 1on1Component3 -->
                        <!-- <div @click="onClickOneItem(oneItem, key, 1)" id="one-item3" class="ibox-child one-child cursor">
                          <div class="flex-box cursor">
                            <img class="one-icon" src="static/img/1on1/img01.png" alt="">
                            <div class="comment">
                              <h4 class="h4">{{$t('thirdContent1on1')}}</h4>
                              <one-item :detailView="false" :item="oneItem.contents[1]"/>
                              <div class="ibox-tools">
                                <span class="info-menu">
                                  <a class="info-comment" >
                                    <img src="static/img/assets/comment.png">
                                    <span>{{ getCommentsByCommentIdsTargetType(key,'1on1s_1').length }}</span>
                                  </a>
                                </span>
                                <span class="info-right"></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- /1on1Component3  -->
                        <!-- 1on1Component4 -->
                        <!-- <div @click="onClickOneItem(oneItem, key,  2)" id="one-item4" class="ibox-child one-child cursor">
                          <div class="flex-box cursor">
                            <img class="one-icon" src="static/img/1on1/img03.png" alt="">
                            <div class="comment">
                              <h4 class="h4">{{$t('fourContent1on1')}}</h4>
                              <one-item :detailView="false" :item="oneItem.contents[2]"/>
                              <div class="ibox-tools">
                                <span class="info-menu">
                                  <a class="info-comment" >
                                    <img src="static/img/assets/comment.png">
                                    <span>{{ getCommentsByCommentIdsTargetType(key,'1on1s_2').length }}</span>
                                  </a>
                                </span>
                                <span class="info-right"></span>
                              </div>
                            </div>
                          </div>
                        </div> -->
                        <!-- /1on1Component4  -->
                        </div>
                        <!-- /ibox-content -->
                      </div>
                      <!-- /1on1item -->
                  </section>
              </div>
        </b-tab>
        <b-tab :title="$t('rtfbType')">
            <div class="panel-body user-itembox" v-if="(tabIndex == 1 && isLiteMode) || (tabIndex == 2 && !isLiteMode)">
                <div class="ibox">
                  <div class="ibox-child"  v-for="(feed, index) in getRtfbsByUser" :key="feed.id" v-if="Object.values(getRtfbs)[0] && feed.feed && feed.feed.contentText" v-observe-visibility="visibilityChanged" :accessKey="index" v-bind:class="{ isForceBrowsing: !!feed.isForceBrowed }">
                      <div @click="onClickRequest(feed.feed, feed.key)" class="flex-box cursor">
                          <span class="info-userimg">
                            <img v-if="getUserInfoById(feed.feed.userId).userIcon" alt="image" class="img-circle" :src="getUserInfoById(feed.feed.userId).userIcon">
                            <img v-else alt="image" class="img-circle" :src="'static/img/noImage.png'">
                          </span>
                          <div class="comment">
                              <fb-item :detailView="false" :item="feed.feed" :itemId="feed.key"/>
                              <div class="child-tools">
                                  <span class="info-menu">
                                      <span class="info-comment">
                                        <img src="static/img/assets/comment.png">
                                        <span v-bind:class="{ unread: isUnreadCommentsExist('rtfbs', feed.key, feed.feed.comments)}">{{ getCommentsByCommentIdsTargetType(feed.feed.comments || {},'rtfbs').length }}</span>
                                      </span>
                                      <a class="info-comment">
                                        <img v-if="isLiked(feed.feed)" @click.stop="onClickStarLiked(feed.feed, feed.key)" :src="'static/img/assets/nice_on.png'">
                                        <img v-else @click.stop="onClickStarNotLiked(feed.feed, feed.key)" :src="'static/img/assets/nice_off.png'">
                                        <span class="like-counter" @click.stop="showModalLikes(feed.feed, feed.key)" v-if="feed.feed.likes"><strong v-bind:class="{ unread: isUnreadLikeExist(feed.key, feed.feed.userId, feed.feed.likes) }">{{ feed.feed.likes ? Object.keys(feed.feed.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
                                      </a>
                                  </span>
                                  <span class="info-right">
                                    <fb-drop-down v-if="getUserId == feed.feed.userId" :item="feed.feed" :id="feed.key"/>
                                  </span>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
            </div>
        </b-tab>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import CommonJs from '@/js/common'
import Objective from '@/components/Okr/Objective'
import OkrDropDown from '@/components/Okr/OkrDropDown'
import SelectDropDown from '@/components/Okr/SelectDropDown'
import RelationItem from '@/components/Okr/RelationItem'
import OneDropDown from '@/components/One/OneDropDown'
import OneItem from '@/components/One/OneItem'
import FbItem from '@/components/Fb/FbItem'
import FbDropDown from '@/components/Fb/FbDropDown'
import CommentItem from '@/components/Comment/CommentItem'
import CommentForm from '@/components/Comment/CommentForm'
import moment from 'moment'
import { content1on1, liteMode } from '@/main'

export default {
  name: 'OtherItems',
  mixins: [CommonJs],
  components: {
    Objective,
    OkrDropDown,
    SelectDropDown,
    RelationItem,
    OneDropDown,
    OneItem,
    FbItem,
    FbDropDown,
    CommentItem,
    CommentForm
  },
  props: {
    userId: String,
    index: {
      type: Number,
      default: 0
    }
  },
  // store,
  data: function () {
    return {
      isLiteMode: liteMode,
      tag: 'progress',
      user: [],
      open: false,
      tabIndex: 0,
      // OKR
      objectiveId: '',
      objectives: [],
      // targetType: 'objectives',
      targetItem: {
        progress: '0',
        contentText: '',
        createdAt: '',
        dueDate: '',
        limitedAccess: {},
        relations: {}
      },
      targetType: '',
      targetItemProgress: 0,
      targetItemKey: '',
      targetKeyresults: {},
      comp: true,
      keyresultOpen: {},
      // 1on1
      targetOneItem: {},
      targetOneItemKey: '',
      // feedback
      feedItems: {},
      detail: {},
      targetFeed: {},
      targetFeedKey: '',
      // targetType: 'rtfbs',
      targetUserId: '',
      targetUserName: '',
      targetUserIcon: '',
      targetContent: '',
      // key: '',
      targetComments: {},
      replyParent: {},
      content1on1: content1on1,
      contentTitle: {
        0: this.$t('firstContent1on1'),
        1: this.$t('secondContent1on1'),
        2: this.$t('thirdContent1on1'),
        3: this.$t('forthContent1on1')
      },
      showCount: [10, 10, 10],
      count: 10,
      modalTargetFeed: {}
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getCurrentUserInfo'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsAdmin',
      'getMetaIsForceBrowsing'
    ]),
    ...mapGetters('rtfbs/', [
      'getRtfbs',
      'getRtfbById',
      'getRtfbsByUserId',
      'getIsReadLike'
    ]),
    ...mapGetters('ones/', [
      'getCurrent1on1s',
      'get1on1ById',
      'get1on1sByUserId'
    ]),
    ...mapGetters('okrs/', [
      'getIsReadRelation'
    ]),
    ...mapGetters('keyResults/', [
      'getOtherUserKeyresultsByIds',
      'getKeyresultById',
      'getCurrentKeyresults'
    ]),
    ...mapGetters('objectives/', [
      'getObjectivesByUserId',
      'getObjectiveById',
      'getCurrentObjectives'
    ]),
    ...mapGetters('comments/', [
      'getCommentsByItemId',
      'getIsReadComment',
      'getCommentsByCommentIdsTargetType'
    ]),
    ...mapGetters('groups/', [
      'getGroupsByIds'
    ]),
    ...mapGetters('users/', [
      'getUsersByIds',
      'getUserInfoById'
    ]),
    checkContent1on1 () {
      return Object.keys(content1on1.content1on1).length
    },
    isAdmin () {
      return this.getMetaIsAdmin
    },
    isForceBrowsing () {
      return this.getMetaIsForceBrowsing
    },
    getObjectivesByUser: function () {
      const currentObjectives = this.getObjectivesByUserId(this.userId, this.isAdmin, this.isForceBrowsing)
      console.log(this.userId)
      let incompletedObjectives = []
      for (const key in currentObjectives) {
        if (!currentObjectives[key].isComplete) {
          incompletedObjectives.push({key: key, objective: currentObjectives[key]})
        } else if (currentObjectives[key].isComplete === false) {
          incompletedObjectives.push({key: key, objective: currentObjectives[key]})
        }
      }
      switch (this.getUserInfoById(this.userId).okrOrder) {
        case 'updated_desc':
          incompletedObjectives.sort(function (a, b) {
            return a.objective.modifiedAt - b.objective.modifiedAt
          })
          break
        case 'updated_asc':
          incompletedObjectives.sort(function (a, b) {
            return b.objective.modifiedAt - a.objective.modifiedAt
          })
          break
        case 'created_asc':
          incompletedObjectives.sort(function (a, b) {
            return b.objective.createdAt - a.objective.createdAt
          })
          break
        case 'created_desc':
        default:
          incompletedObjectives.sort(function (a, b) {
            return a.objective.createdAt - b.objective.createdAt
          })
      }
      return incompletedObjectives.reverse().slice(0, this.showCount[0])
    },
    orderType () {
      let ret = this.getUserInfoById(this.userId).okrOrder
      switch (ret) {
        case 'updated_desc':
          return this.$t('updateDescending')
        case 'updated_asc':
          return this.$t('updateAscending')
        case 'created_asc':
          return this.$t('registerAscending')
        case 'created_desc':
        default:
          return this.$t('registerDescending')
      }
    },
    get1on1sByUser: function () {
      let get1on1s = this.get1on1sByUserId(this.userId, this.isAdmin, this.isForceBrowsing)
      let onesForShow = []
      console.log('get1on1s::::', get1on1s)
      for (let oneKey in get1on1s) {
        console.log('oneKey::::', oneKey)
        if (get1on1s[oneKey] && get1on1s[oneKey].contents) {
          console.log('get1on1s[oneKey]::::', get1on1s[oneKey])
          get1on1s[oneKey].date = get1on1s[oneKey].date.replace(/-/g, '/')
          onesForShow.push({
            key: oneKey,
            one: get1on1s[oneKey]
          })
        }
      }
      console.log('onesForShow::::', onesForShow)
      return onesForShow.reverse().slice(0, this.showCount[1])
      // for (let keys in get1on1s) {
      //   // console.log(get1on1s[keys].date)
      //   get1on1s[keys].date = this.get1on1sByUserId(this.userId)[keys].date.replace(/-/g, '/')
      // }
      // return get1on1s
    },
    getRtfbsByUser: function () {
      return this.getRtfbsByUserId(this.userId, this.getUserId, this.isAdmin, this.isForceBrowsing).reverse().slice(0, this.showCount[2])
    },
    // ここから、他人のアイテム表示用の関数
    getCurrentIncompletedObjectives: function () {
      let incompletedObjectives = []
      const currentObjectives = this.getCurrentObjectives
      for (const key in currentObjectives) {
        if (currentObjectives[key]) {
          if (!currentObjectives[key].isComplete) {
            incompletedObjectives.push({key: key, objective: currentObjectives[key]})
          } else if (currentObjectives[key].isComplete === false) {
            incompletedObjectives.push({key: key, objective: currentObjectives[key]})
          }
        }
      }
      switch (this.getUserInfoById(this.userId).okrOrder) {
        case 'updated_desc':
          incompletedObjectives.sort(function (a, b) {
            return a.objective.modifiedAt - b.objective.modifiedAt
          })
          break
        case 'updated_asc':
          incompletedObjectives.sort(function (a, b) {
            return b.objective.modifiedAt - a.objective.modifiedAt
          })
          break
        case 'created_asc':
          incompletedObjectives.sort(function (a, b) {
            return b.objective.createdAt - a.objective.createdAt
          })
          break
        case 'created_desc':
        default:
          incompletedObjectives.sort(function (a, b) {
            return a.objective.createdAt - b.objective.createdAt
          })
      }
      return incompletedObjectives.reverse()
    },
    getModalLikesTarget () {
      return this.modalTargetFeed
    },
    getTargetLimitedAccess () {
      if (!this.targetItem.limitedAccess) {
        return {}
      } else if (this.targetItem.limitedAccess.limitedUsers) {
        return this.getUsersByIds(Object.keys(this.targetItem.limitedAccess.limitedUsers))
        // return !this.targetItem.limitedAccess.limitedGroup ? this.getUsersByIds(this.targetItem.limitedAccess.limitedUsers.keys) : this.targetItem.limitedAccess.limitedGroup
      } else if (this.targetItem.limitedAccess.limitedGroup) {
        // return this.targetItem.limitedAccess.limitedGroup
        return this.getGroupsByIds([this.targetItem.limitedAccess.limitedGroup])
      }
    },
    getRelationLength () {
      return this.targetItem.relations ? Object.keys(this.targetItem.relations).length : 0
    },
    getTargetOkrComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetItem.comments || {}, this.targetType)
    },
    getTargetOneItemComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetOneItem.comments || {}, this.targetType)
    },
    getTargetFbComments () {
      return this.getCommentsByCommentIdsTargetType(this.targetFeed.comments || {}, this.targetType)
    }
  },
  watch: {
    tabIndex: function (value) {
      for (const i in this.showCount) {
        this.$set(this.showCount, i, i === value ? this.showCount[i] : this.count)
      }
    },
    index: function (value) {
      this.tabIndex = value
    }
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('rtfbs/', {
      // VuexFireからのActionを読み込み
      setLikes: 'SET_LIKES',
      removeLikes: 'REMOVE_LIKES'
    }),
    ...mapActions('ones/', {
      // VuexFireからのActionを読み込み
      setOneLikes: 'SET_ONES_LIKES',
      removeOneLikes: 'REMOVE_ONES_LIKES'
    }),
    // ここから、他人のアイテム表示用の関数
    onClickObjective: function (obj, key) {
      console.log(obj, key)
      this.targetItem = obj
      this.targetItemKey = key
      this.targetType = 'objectives'
      this.targetItemProgress = this.targetItem.progress
      this.targetItem.progress = this.targetItem.progress ? this.targetItem.progress : '0'
      this.updateTarget()
    },
    onClickKeyresult: function (obj, key) {
      console.log(obj, key)
      this.targetItem = obj
      this.targetItemKey = key
      this.targetType = 'keyresults'
      this.targetItemProgress = this.targetItem.progress
      this.targetItem.progress = this.targetItem.progress ? this.targetItem.progress : '0'
      this.updateTarget()
    },
    updateTarget: function () {
      let value
      console.log('updatetarget')
      if (this.targetType === 'objectives' || this.targetType === 'keyresults') {
        console.log('updateTarget in objective')
        value = {
          targetType: this.targetType,
          targetItem: this.targetItem,
          targetItemKey: this.targetItemKey
        }
      } else if (this.targetType.match(/1on1s_/)) {
        console.log('updateTarget in 1on1')
        value = {
          targetOneItem: this.targetOneItem,
          targetOneItemKey: this.targetOneItemKey,
          targetContent: this.targetContent,
          targetType: this.targetType
        }
      } else if (this.targetType === 'rtfbs') {
        console.log('updateTarget in rtfbs')
        value = {
          targetFeed: this.targetFeed,
          targetFeedKey: this.targetFeedKey,
          targetUserName: this.targetUserName,
          targetUserIcon: this.targetUserIcon,
          targetType: this.targetType,
          targetUserId: this.targetUserId
        }
        console.log(this.targetFeed)
        // this.open = true
      }
      this.$emit('set-target', value)
    },
    setKeyresultOpen: function (objectiveId) {
      Vue.set(this.keyresultOpen, objectiveId, Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? true : !this.keyresultOpen[objectiveId])
    },
    getIsOpen: function (objectiveId) {
      return Object.keys(this.keyresultOpen).filter(x => x === objectiveId).length === 0 ? false : this.keyresultOpen[objectiveId]
    },
    getOtherUserTargetKeyresults (userId, keyresultsObject) {
      // 算出プロパティだと引数がつけられないためmethodに
      console.log('keyresultobj', keyresultsObject)
      return keyresultsObject ? this.getOtherUserKeyresultsByIds(userId, Object.keys(keyresultsObject), this.isAdmin, this.isForceBrowsing) : {}
    },
    getIsComp: function (item) {
      return Object.keys(item).filter(x => x === 'isComplete').length === 0 ? false : item.isComplete === 1
    },
    onClickOneItem: function (oneItem, key, content) {
      this.targetOneItem = !oneItem ? [] : oneItem
      this.targetOneItemKey = key
      this.targetContent = content
      this.targetType = '1on1s_' + content
      this.updateTarget()
    },
    onClickRequest: function (feed, key) {
      console.log('onclick Request')
      this.targetFeed = !feed ? [] : feed
      console.log(this.targetFeed.contentText)
      this.targetFeedKey = key
      this.targetUserId = feed.userId
      this.targetType = 'rtfbs'
      this.targetUserName = this.getUserInfoById(feed.userId).userName
      this.targetUserIcon = this.getUserInfoById(feed.userId).userIcon
      this.updateTarget()
    },
    onClickStarLiked: function (feed, key) {
      this.removeLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarNotLiked: function (feed, key) {
      this.setLikes({
        key: key,
        userId: this.getUserId
      })
    },
    get1on1UnreadCommentKeys (itemType, itemId, allCommentsIds) {
      let targetComments = this.getCommentsByCommentIdsTargetType(allCommentsIds, itemType)
      for (let i = 0; i < targetComments.length; i++) {
        if (!this.getIsReadComment(itemType, this.userId, itemId, targetComments[i].id)) {
          return true
        }
      }
      return false
    },
    isUnreadCommentsExist (itemType, itemId, commentIds) {
      for (let commentId in commentIds) {
        if (!this.getIsReadComment(itemType, this.userId, itemId, commentId)) {
          return true
        }
      }
      return false
    },
    isUnreadOKRRelationExist (obj, key, itemType) {
      for (let relationKey in obj.relations) {
        if (!this.getIsReadRelation(itemType, this.userId, key, relationKey)) {
          return true
        }
      }
      return false
    },
    isUnreadLikeExist (rtfbsKey, rtfbsOwnerId, likeOwners) {
      for (let likeOwner in likeOwners) {
        if (!this.getIsReadLike(rtfbsOwnerId, rtfbsKey, likeOwner)) {
          return true
        }
      }
      return false
    },
    isUnreadOneLikeExist (onesKey, OwnerId, likeOwners, number) {
      for (let likeOwner in likeOwners) {
        if (!this.getIsReadLike(OwnerId, onesKey, likeOwner, number)) {
          return true
        }
      }
      return false
    },
    showModalLikes: function (feed, key) {
      // this.modalTargetFeed = feed
      console.log('showModalLikes', feed)
      for (let likeOwner in feed.likes) {
        if (!this.getIsReadLike(feed.userId, key, likeOwner)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: 'rtfbs',
            targetOwner: feed.userId,
            targetId: key,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      this.$emit('show-modal-likes', feed)
      // this.$refs.modalLikes.showModal()
    },
    showOneModalLikes (value, number) {
      const item = value.one
      for (let likeOwner in item['likes'][String(number)]) {
        if (!this.getIsReadLike(this.userId, value.keykey, likeOwner, number)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: '1on1s_' + String(number),
            targetOwner: this.userId,
            targetId: value.keykey,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      let targetlikes = item
      targetlikes['likes'] = item['likes'][String(number)]
      targetlikes['userId'] = this.userId
      targetlikes['userName'] = this.getUserInfoById(this.userId).userName
      targetlikes['contentText'] = item['contents'][String(number)]
      targetlikes['createdAt'] = item['date']
      targetlikes['itemType'] = '1on1'
      this.$emit('show-modal-likes', targetlikes)
    },
    isLiked: function (feed) {
      if (!feed.likes) {
        return false
      } else {
        return Object.keys(feed.likes).filter(x => x === this.getUserId).length !== 0
      }
    },
    isOneLiked: function (likes, number) {
      if (!likes || !likes.hasOwnProperty(number)) {
        return false
      } else {
        return Object.keys(likes[number]).filter(x => x === this.getUserId).length !== 0
      }
    },
    onClickOneStarNotLiked: function (key, number) {
      this.setOneLikes({
        key: key,
        userId: this.userId,
        contentKey: number,
        targetUserId: this.userId
      })
    },
    onClickOneStarLiked: function (key, number) {
      this.removeOneLikes({
        key: key,
        userId: this.userId,
        contentKey: number,
        targetUserId: this.userId
      })
    },
    onClickStarToggle: function (feed, key) {
      if (this.isLiked(feed)) {
        this.onClickStarLiked(feed, key)
      } else {
        this.onClickStarNotLiked(feed, key)
      }
    },
    visibilityChanged (isVisible, entry) {
      if (entry.isIntersecting && Number(entry.target.accessKey) === this.showCount[this.tabIndex] - 1) {
        this.$set(this.showCount, this.tabIndex, this.showCount[this.tabIndex] + 20)
      }
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.keyResultClose .ibox-child {
    height: 0;
    margin: 0 auto;
    padding-top: 0;
    padding-bottom: 0;
    overflow:  hidden;
    border: none;
  }
  .fa-chevron-down{
    transition: all 0.2s ease-in-out;
  }
  .chevronUp{
    transform: rotate(180deg);
  }
  .user-itembox {
    padding: 0 1rem;
  }
  .partner-userimg img{
    width: 3em;
    height: 3em;
    object-fit: cover;
  }
  .partner-userinfo {
    display: inline-block;
    vertical-align: middle;
  }
  .star{
    width: 2.0rem;
  }
  .isForceBrowsing {
    border: 3px solid #cc0;
  }
</style>



// WEBPACK FOOTER //
// src/components/User/OtherItems.vue